import { Navigate, useRoutes } from 'react-router-dom';

// Landing Page Routes
import ForgotPassword from './Components/Home/ForgotPassword';
import HomePage from './Components/Home/HomePage';
import { ContactUsEmail } from './Components/Home/Modules/Views/ContactUsEmail';
import { ProductCategories } from './Components/Home/Modules/Views/ProductCategories';
import { ProductFeatures } from './Components/Home/Modules/Views/ProductFeatures';
import { ProductHowItWorks } from './Components/Home/Modules/Views/ProductHowItWorks';
import Privacy from './Components/Home/Privacy';
import SignIn from './Components/Home/SignIn';
import SignUp from './Components/Home/SignUp';
import Terms from './Components/Home/Terms';

// Core Application Page Routes
import DashboardLayout from './Components/CoreApp/layouts/dashboard';
import Blog from './Components/CoreApp/pages/Blog';
import BlogDetail from './Components/CoreApp/pages/BlogDetail';
import { CoreApp } from './Components/CoreApp/pages/CoreApp';
import Matter from './Components/CoreApp/pages/Matter';
import MatterDetailPage from './Components/CoreApp/pages/MatterDetailPage';
import NotificationsPage from './Components/CoreApp/pages/NotificationsPage';
import ProfilePage from './Components/CoreApp/pages/ProfilePage';
import Register from './Components/CoreApp/pages/Register';
import SettingsPage from './Components/CoreApp/pages/SettingsPage';
import TaskTablePage from './Components/CoreApp/pages/TaskTablePage';
import UserAdmin from './Components/CoreApp/pages/UserAdmin';
import ResetpasswordPage from './Components/Home/ResetpasswordPage';
import MailList from './Components/CoreApp/pages/MailList';

// 🚨 1. IMPORT THE NEW PUBLIC COMPONENT
import MatterPublicSummaryPage from './Components/CoreApp/pages/MatterSummaryPage';

export const Router = () => {
  return useRoutes([
    // Landing Page Routes
    {
      path: '/',
      element: <HomePage />,
      children: [
        { path: 'homepage', element: <HomePage /> },
        { path: 'features', element: <ProductFeatures /> },
        { path: 'howitworks', element: <ProductHowItWorks /> },
        { path: 'prodcategories', element: <ProductCategories /> },
        { path: 'contactus', element: <ContactUsEmail /> },
      ],
    },
    {
      path: '/signin',
      element: <SignIn />,
    },
    {
      path: '/signup',
      element: <SignUp />,
    },
    {
      path: '/terms',
      element: <Terms />,
    },
    {
      path: '/privacy',
      element: <Privacy />,
    },
    {
      path: '/forgotpassword',
      element: <ForgotPassword />,
    },
    {
      path: '/reset-password',
      element: <ResetpasswordPage />,
    },

    // 🚨 2. ADD THE NEW PUBLIC ACCESS ROUTE (No Dashboard Layout)
    {
        path: 'matter-public/:id/summary',
        element: <MatterPublicSummaryPage />,
    },
    
    // Core Application Routes (Dashboard layout with Matter integration)
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        { path: 'coreapp', element: <CoreApp /> },
        { path: 'users', element: <UserAdmin /> },
        { path: 'matter', element: <Matter /> },
        { path: 'mail-list', element: <MailList /> },
        { path: 'blog', element: <Blog /> },
        { path: 'post/:id', element: <BlogDetail /> },
        { path: 'profile', element: <ProfilePage /> },
        { path: 'settings', element: <SettingsPage /> },
        { path: 'matter/:id', element: <MatterDetailPage /> },
        { path: 'tasktable', element: <TaskTablePage /> },
        { path: 'NotificationsPage',  element: <NotificationsPage />},
      ],
    },
  ]);
};
